import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import Success from "../Assets/success_gif.gif";
import "./CSS/HelpSupport.css";
import { FaChevronDown } from "react-icons/fa";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  handleAphabetsChange,
  handleError,
  handleSuccessSession,
} from "../CommonJquery/CommonJquery.js";
import {
  server_post_data,
  ticket_save,
} from "../ServiceConnection/serviceconnection.js";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
function CreateNewTicket({ setTicketTabs }) {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  const [ticketType, setTicketType] = useState("");
  const [priority, setPriority] = useState("Choose Priority");
  const [ticketBody, setTicketBody] = useState("");
  const [otherTicketType, setOtherTicketType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isTicketTypeOpen, setIsTicketTypeOpen] = useState(false);
  const [isPriorityOpen, setIsPriorityOpen] = useState(false);
  const name = retrieveData("final_full_name");
  const email = retrieveData("final_user_email");
  const closeModal = () => {
    setShowModal(false);
  };

  const ticketNAme = [
    { name: "Bug", code: "Bug" },
    { name: "Feature Request", code: "Feature Request" },
    { name: "Amendment", code: "Ammendment" },
    { name: "Upgradation", code: "Upgradation" },
    { name: "KB Update", code: "KB Update" },
    { name: "Other", code: "Other" },
  ];

  const priorityArray = [
    { name: "High", code: "High" },
    { name: "Medium", code: "Medium" },
    { name: "Low", code: "Low" },
  ];

  const handleAphabetsChange = (e) => {
    // Get the input value from the event
    const input = e.target.value;

    // Remove leading spaces and replace non-alphabetic characters
    const sanitizedValue = input.replace(/^\s+|[^A-Za-z\s]/g, "");

    // Return the sanitized value
    return sanitizedValue;
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      const ticketTypeValue =
        ticketType === "Other" ? otherTicketType : ticketType;
      let fd_from = combiled_form_data(form_data, null);
      // Append additional fields
      fd_from.append("cus_subject", ticketTypeValue);
      fd_from.append("final_full_name", name);
      fd_from.append("final_user_email", email);
      setshowLoaderAdmin(true);

      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          let data = Response.message.split("~@~");

          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            handleSuccessSession(final_data.message, "/Support");
            empty_form(form_data);
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };

  const handleReviewClose = () => {
    setTicketTabs("Tickets");
  };

  console.log(otherTicketType);
  return (
    <div className="dashboard">
      {/* {showLoaderAdmin && <Loader />} */}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <div className="page_body">
              <div className="create_staffRights container-lg">
                <div className="Suppotr_wrapper gmb-premium">
                  <div className="newticket-container">
                    <div className="newticket_head">
                      <div className="d-flex gap-1">
                        <button
                          className="text-secondary-light d-flex me-8"
                          onClick={handleReviewClose}
                        >
                          <Icon
                            icon="mingcute:arrow-left-line"
                            className="icon fs-3 line-height-1"
                          />
                        </button>
                        <h6>Create Quick Ticket</h6>
                      </div>
                      <p>Write and address new queries and issues</p>
                    </div>
                    <form id="createRightsForm">
                      <div className="newTicketform">
                        <div className="row m-0">
                          <div className="col-md-4">
                            <div className="form-row" style={{ margin: 0 }}>
                              <label>Request Ticket Type</label>
                              <br />

                              <div
                                className="select-wrapper"
                                style={{ position: "relative" }}
                              >
                                <select
                                  value={ticketType}
                                  onChange={(e) => {
                                    setTicketType(e.target.value);
                                    if (e.target.value !== "Other") {
                                      setOtherTicketType(""); // Reset 'Other' input when another option is selected
                                    }
                                  }}
                                  placeholder="Choose Type"
                                  className="priorityBtn trio_mandatory form-control"
                                  id="cus_subject"
                                  name="cus_subject"
                                  onFocus={() => setIsTicketTypeOpen(true)}
                                  onBlur={() => setIsTicketTypeOpen(false)}
                                  style={{
                                    paddingTop: "8px",
                                    paddingBottom: "8px",
                                    paddingRight: "30px",
                                    appearance: "none",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <option value=" " hidden>
                                    Choose Type
                                  </option>
                                  {ticketNAme.map((item, index) => (
                                    <option key={index} value={item.code}>
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                                <FaChevronDown
                                  className={`chevron-icon ${
                                    isTicketTypeOpen ? "rotate" : ""
                                  }`}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "14px",
                                    pointerEvents: "none",
                                  }}
                                />
                              </div>

                              <span className="condition_error"></span>
                            </div>
                            {/* Render input box if 'Other' is selected in ticket type */}
                            {ticketType === "Other" && (
                              <div className="form-row">
                                <label>Specify Ticket Type</label>
                                <br />
                                <input
                                  type="text"
                                  id="cus_subject1"
                                  name="cus_subject1"
                                  value={otherTicketType}
                                  onChange={(e) => {
                                    const updatedValue = e.target.value.replace(
                                      /^\s+|[^A-Za-z\s]/g,
                                      "",
                                    );
                                    setOtherTicketType(updatedValue);
                                  }}
                                  className="priorityBtn trio_mandatory form-control "
                                  style={{ backgroundColor: "#ffffff" }}
                                  placeholder="Enter Ticket Type"
                                />
                              </div>
                            )}
                          </div>

                          <div className="col-md-4">
                            <div className="form-row">
                              <label>Priority Status</label>
                              <br />
                              <div
                                className="select-wrapper"
                                style={{ position: "relative" }}
                              >
                                <select
                                  value={priority}
                                  onChange={(e) => setPriority(e.target.value)}
                                  placeholder="Choose Type"
                                  optionLabel="name"
                                  id="cus_priority"
                                  name="cus_priority"
                                  onFocus={() => setIsPriorityOpen(true)}
                                  onBlur={() => setIsPriorityOpen(false)}
                                  className="priorityBtn trio_mandatory form-control"
                                  style={{
                                    paddingTop: "8px",
                                    paddingBottom: "8px",
                                  }}
                                >
                                  <option value=" " hidden>
                                    Choose Type
                                  </option>
                                  {priorityArray.map((item, index) => (
                                    <option key={index} value={item.code}>
                                      {item.name}
                                    </option>
                                  ))}
                                </select>

                                <FaChevronDown
                                  className={`chevron-icon ${
                                    isPriorityOpen ? "rotate" : ""
                                  }`}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "14px",
                                    pointerEvents: "none",
                                  }}
                                />
                              </div>

                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>
                        <div className="form-row" style={{ padding: "0 12px" }}>
                          <label>Ticket Body</label>
                          <br />
                          <textarea
                            rows="7"
                            value={ticketBody}
                            id="description"
                            name="description"
                            className="priorityBtn trio_mandatory form-control"
                            onChange={(e) => setTicketBody(e.target.value)}
                          />
                          <span className="condition_error"></span>
                        </div>
                      </div>
                    </form>
                    <div
                      className="newticketSubmitBtn"
                      style={{ padding: "0 12px" }}
                    >
                      <button
                        onClick={() =>
                          handleSaveChangesdynamic(
                            "createRightsForm",
                            ticket_save,
                          )
                        }
                        type="button"
                      >
                        Send Ticket
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        id="myModal"
        show={showModal}
        onHide={closeModal}
        centered
        backdrop="static"
      >
        <Modal.Body className="modal_body">
          <div className="success_img d-flex justify-content-center">
            <img src={Success} alt="icon" />
          </div>
          <p>
            Your ticket has been send successfully. Click on the button below to
            see your tickets.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Link to="/Help">
            <div className="btn go_to_login">View Tickets</div>
          </Link>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default CreateNewTicket;
